import { supabase } from "@/utils/supabase";
import { ServiceVehicleMapper } from "@/adapters/ServiceVehicle.mapper";
import { getRootStore } from "@/stores/RootStore";
export class ServiceVehicleService {
    async getVehiclesWithParams(params) {
        try {
            let query = supabase()
                .from("ServiceVehicles")
                .select("*", { count: "exact" })
                .eq("isDeleted", false);
            // Фильтры
            if (params.filters) {
                const search = params.filters.search?.trim();
                if (search) {
                    const ors = [
                        `licensePlate.ilike.*${search}*`,
                        `brand.ilike.*${search}*`,
                        `model.ilike.*${search}*`,
                    ];
                    query = query.or(ors.join(","));
                }
            }
            // Сортировка
            if (params.sorters && Object.keys(params.sorters).length > 0) {
                Object.entries(params.sorters).forEach(([field, order]) => {
                    if (order === "ascend")
                        query = query.order(field, { ascending: true });
                    else if (order === "descend")
                        query = query.order(field, { ascending: false });
                });
            }
            else {
                query = query.order("licensePlate", { ascending: true });
            }
            // Пагинация
            const from = (params.page - 1) * params.pageSize;
            query = query.range(from, from + params.pageSize - 1);
            const { data, error, count } = await query;
            if (error)
                throw error;
            return {
                data: data.map(ServiceVehicleMapper.toDomain),
                total: count || 0,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            console.error("Error in getVehiclesWithParams:", error);
            throw error;
        }
    }
    async getVehiclesByIds(ids) {
        if (!ids.length)
            return [];
        const { data, error } = await supabase()
            .from("ServiceVehicles")
            .select("*")
            .in("id", ids)
            .eq("isDeleted", false)
            .order("licensePlate");
        if (error)
            throw error;
        return data.map(ServiceVehicleMapper.toDomain);
    }
    async createVehicle(vehicle) {
        const { data, error } = await supabase()
            .from("ServiceVehicles")
            .insert([
            {
                ...ServiceVehicleMapper.toCreateDto(vehicle),
                idCreatedBy: getRootStore().authStore.user?.id,
            },
        ])
            .select("*")
            .single();
        if (error)
            throw error;
        return ServiceVehicleMapper.toDomain(data);
    }
    async updateVehicle(id, vehicle) {
        const { data, error } = await supabase()
            .from("ServiceVehicles")
            .update({
            ...ServiceVehicleMapper.toCreateDto(vehicle),
            idUpdatedBy: getRootStore().authStore.user?.id,
        })
            .eq("id", id)
            .select("*")
            .single();
        if (error)
            throw error;
        return ServiceVehicleMapper.toDomain(data);
    }
    async deleteVehicle(id) {
        const { error } = await supabase()
            .from("ServiceVehicles")
            .update({
            isDeleted: true,
            idUpdatedBy: getRootStore().authStore.user?.id,
        })
            .eq("id", id);
        if (error)
            throw error;
    }
}
// Экспортируем singleton
export const serviceVehicleService = new ServiceVehicleService();
